import React from 'react';
export const NotFound = ({ errorText }) => (React.createElement("div", { className: 'pageContainer' },
    React.createElement("span", { className: 'error_page_message' }, errorText)));
export default NotFound;
